import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Loader } from 'Components/Loader';
import { clearPlans } from 'State/Plans/PlansActions';
import { getEntitlements } from 'State/User/UserActions';
import { Confirmation } from 'Features/Confirmation/Confirmation';
import { loadKerv } from 'Utils/Analytics/Kerv';

export function ConfirmationContainer({ location }) {
  const dispatch = useDispatch();
  const { hasEntitlements } = useSelector((s) => s.user);

  useEffect(() => {
    if (hasEntitlements) {
      loadKerv();
    }
  }, [hasEntitlements]);

  useEffect(() => {
    /* Clearing sign up plans so that if go to change plans it will fetch appropriate packages */
    dispatch(getEntitlements(1));
    dispatch(clearPlans());
  }, [dispatch]);

  return <div className="confirmationContainer">{hasEntitlements ? <Confirmation /> : <Loader />}</div>;
}
